//https://github.com/stripe-samples/identity-verification/tree/master/screenshots

import Vue from "vue";
import App from "./App.vue";
// import Home from "././views/Home.vue"
import router from "./router";

import VueMaterial from "vue-material";
import "vue-material/dist/vue-material.min.css";
import "vue-material/dist/theme/default.css";

import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import { Camera } from "vue-capture";
import VueClipboard from 'vue-clipboard2'
import VueResizeObserver from "vue-resize-observer";

import axios from "axios";

if (process.env.NODE_ENV === 'development') {
    console.log('dev move');
    axios.defaults.baseURL = 'https://verify-test.secureidverify.com';
}

Vue.use(VueClipboard)

Vue.use(VueMaterial);
Vue.component('vue-phone-number-input', VuePhoneNumberInput);
Vue.component('camera',Camera);

Vue.use(VueResizeObserver);

Vue.config.productionTip = false;

new Vue({
    router,
    render: (h) => h(App),
}).$mount("#app");